import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import {postSubmit, isEmpty, scrollToComponent, stringToDate, formatDate, FORMAT_DATE_BACK} from "@ui-seeker/utils"

// This lives under Pricing but calls a **stock** endpoint, migrated to the v2 webback.
import { WEBBACK_V2_API } from "@constants"
import { evolutionStockDataFilters } from "../../../@signals"


export default function usePriceDiscountStockEvolutionChartData() {
	const { showToast } = useAppToast()

	const dataEvolution = useSignal({})
	const dataEvolutionKeys = useSignal({})
	const dataEvolutionColor = useSignal({})
	const dataEvolutionStatus = useSignal({})
	const skuName = useSignal('')
	const retailerName = useSignal('')
    const dateRange = useSignal([])
	const isLoadingDataEvolution = useSignal(false)

    useEffect(() => {
		if (!isEmpty(evolutionStockDataFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}
			showToast.promise(postSubmit(`${WEBBACK_V2_API}/stock-assortment/details/evolution`, evolutionStockDataFilters.value).then(res => batch(() => {
				dataEvolution.value = res.chart
				dataEvolutionKeys.value = res.keysData
				dataEvolutionColor.value = res.keysColor
				dataEvolutionStatus.value = res.statusList
				skuName.value = res.skuName
				retailerName.value = res.retailer
                dateRange.value = [stringToDate(evolutionStockDataFilters.value.startDate), stringToDate(evolutionStockDataFilters.value.endDate)]
                isLoadingDataEvolution.value = false
			})).catch(() => showToast.error()
            ).finally(() => scrollToComponent('evolution-status-chart')))
		}) 

		if (isEmpty(evolutionStockDataFilters.value)) batch(() => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = {}
		})

	}, [JSON.stringify(evolutionStockDataFilters.value)])

    const onChange = (e) => {
        batch(() => {
            dateRange.value = e
            evolutionStockDataFilters.value = {
                ...evolutionStockDataFilters.value,
                startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK }),
            }
        })
    }

    const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		dataEvolutionColor.value = {}
		dataEvolutionStatus.value = {}
		evolutionStockDataFilters.value = {}
	})

	return {
		dataEvolution: dataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		dataEvolutionColor: dataEvolutionColor.value,
		dataEvolutionStatus: dataEvolutionStatus.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		skuName: skuName.value,
		retailerName: retailerName.value,
        dateRange: dateRange.value,

        onChange,
        resetEvolutionData
	}
}